<template>
  <div class="about-area">
    <div class="container">
      <!-- Trending Tittle -->
      <div class="row">
        <div class="col-lg-12">
          <div class="trending-tittle"></div>
        </div>
      </div>
      <div class="row">
        <div class="col-lg-8">
          <!-- Trending Tittle -->
          <div class="about-right mb-90">
            <div class="section-tittle mb-30 pt-30">
              <h3 style="text-align: center;">TRÌNH TỰ THỰC HIỆN PHIÊN ĐẤU GIÁ BẰNG HÌNH THỨC ĐẤU GIÁ TRỰC TUYẾN</h3>
            </div>
            <div class="about-prea" style="text-align: justify;">
              <p class="about-pera1">
                Khi tổ chức các phiên đấu giá tài sản bằng hình thức đấu giá trực tuyến, Công ty Đấu giá hợp danh Số 5 –
                Quốc gia luôn thực hiện trình tự, thủ tục đấu giá tài sản theo quy định tại Chương III và Chương IV của
                Luật đấu giá tài sản và quy định tại Chương III của Nghị định 62/2017/NĐ-CP. Cụ thể, trình tự thực hiện
                một phiên đấu giá tài sản bằng hình thức đấu giá trực tuyến như sau:
              </p>
              <p class="about-pera1">
                1. Tổ chức đấu giá tài sản đăng tải Quy chế phiên đấu giá trên Trang thông tin điện tử đấu giá trực
                tuyến.
              </p>
              <p class="about-pera1">
                2. Khi đăng ký tham gia đấu giá, người tham gia đấu giá được cấp một tài khoản truy cập; được hướng dẫn
                về cách sử dụng tài khoản, cách trả giá và các nội dung cần thiết khác trên Trang thông tin điện tử đấu
                giá trực tuyến để thực hiện việc đấu giá trực tuyến.
              </p>
              <p class="about-pera1">
                3. Người tham gia đấu giá sử dụng tài khoản của mình và thực hiện việc trả giá theo phương thức đấu giá,
                thời điểm bắt đầu tiến hành đấu giá và thời điểm kết thúc đấu giá, bước giá đã được công bố.
              </p>
              <p class="about-pera1">
                4. Tại thời điểm kết thúc phiên đấu giá, đấu giá viên được tổ chức đấu giá tài sản, phân công chịu trách
                nhiệm tổ chức thực hiện phiên đấu giá trực tuyến xác định người trúng đấu giá như sau:
              </p>
              <p class="about-pera1">
                a) Trường hợp việc trả giá được thực hiện bằng phương thức trả giá lên thì người trúng đấu giá là người
                có mức trả giá cao nhất được hệ thống thông tin đấu giá trực tuyến ghi nhận tại thời điểm kết thúc việc
                trả giá;
              </p>
              <p class="about-pera1">
                b) Trường hợp việc trả giá được thực hiện bằng phương thức đặt giá xuống thì người trúng đấu giá là
                người đầu tiên chấp nhận mức giá khởi điểm hoặc giá đã giảm được hệ thống thông tin đấu giá trực tuyến
                ghi nhận.
              </p>
              <p class="about-pera1">
                5. Đấu giá viên được tổ chức đấu giá tài sản phân công chịu trách nhiệm tổ chức thực hiện phiên đấu giá
                trực tuyến căn cứ kết quả xác định người trúng đấu giá quy định tại khoản 4 Điều này công bố người trúng
                đấu giá trên hệ thống đấu giá trực tuyến ngay sau khi phiên đấu giá kết thúc.
              </p>
              <p class="about-pera1">
                6. Kết quả phiên đấu giá trực tuyến được đăng công khai trên hệ thống đấu giá trực tuyến và được gửi vào
                địa chỉ điện tử của người tham gia đấu giá đã đăng ký với tổ chức đấu giá tài sản ngay sau khi công bố
                người trúng đấu giá trên hệ thống đấu giá trực tuyến.
              </p>
              <p class="about-pera1">
                Công ty Đấu giá Hợp danh Số 5 – Quốc gia cam kết thực hiện đúng và đầy đủ trình tự, thủ tục tổ chức
                phiên đấu giá bằng hình thức đấu giá trực tuyến theo quy định của pháp luật. Với bề dày kinh nghiệm và
                uy tín đã được tích lũy trong thời gian qua, chúng tôi tin tưởng sẽ luôn đồng hành cùng khách hàng để
                vượt qua khó khăn, nắm bắt cơ hội để cùng nhau xây dựng một thị trường đấu giá tài sản công khai, minh
                bạch và phát triển bền vững.
              </p>
              <p class="about-pera1">Trân trọng./.</p>
            </div>
          </div>
        </div>
        <div class="col-lg-4"></div>
      </div>
    </div>
  </div>
</template>

<script>
import mixin from '@/mixins/mixin.js';
export default {
  name: 'About',
  mixins: [mixin],
  data() {
    return {};
  },
  methods: {}
};
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/components/News/3.vue